	import EventBus from '@/event-bus';
	import axios 	from 'axios'
	import io 		from 'socket.io-client';
	import MenuOptionsDashboard from "@/components/dashboard/MenuOptionsDashboard.vue"
	import MenuProfilesDashboard from "@/components/dashboard/MenuProfilesDashboard.vue"
	

	export default{
		name  		: 'toolbar',
		components : {MenuOptionsDashboard, MenuProfilesDashboard},		
		props : [ 
			'breaks', 
			'is_user',
			'current_router'
		], // props
		data  : (vn) => ({
			system 				: [],			
		 	cpu 				: '',
		 	percent_cpu 		: '',
		 	os_ram 				: 0,
			percent 			: 0,
			disks 				: null,
			resize 				: 0,
			alertMode 			: 'snack',
			grid_options_arr	: [],
			listAlertModes :[
				{ key : "snack" , text: "minimized" },  // minimized
				{ key : "alert" , text: "maximized" }, // maximized 
			],							
			message 			: {},			
			virtual_Keyboard 	: false,
			alr_sound 			: false,
			is_default  		: false,	
			width_toolbar		: {
				bar 		: 705,
				bar_min 	: 500,
				bar_max 	: 705,
				mw_card_cpu : 100,
				mw_card_ram : 100,
				w_card_cpu  : 245,
				w_card_ram  : 240,
				cpu 		: true,
				ram 		: true,
				profile 	: true,
				draggable 	: true,
				keyboard 	: false,
				options 	: false,
				sound   	: true,
				refresh 	: true, 
			},		
			option_active :{
				keyboard 	: false,
				sound 		: false,
				refresh 	: true,
			},
			toolbar_options : [
				{
					"key"  		: "keyboard",
					"text" 		: "keyboard",					
					"type" 		: "btn",
					"key_ctl"   : "virtual_Keyboard",
					"action" 	: "keyboard",
					"tooltip" 	: "",					
					"color" 	: "primary",
					"color1" 	: "white",
					"icon"   	: "mdi-keyboard",
					"icon_off"	: "mdi-keyboard",
					"enable" 	: true,		

				},
				{
					"key"  		: "sound",
					"text" 		: "sound",					
					"type" 		: "btn",
					"key_ctl"   : "alr_sound",
					"action" 	: "sound",
					"tooltip" 	: "",					
					"color" 	: "primary",
					"color1" 	: "white",
					"icon"   	: "mdi-volume-high",
					"icon_off" 	: "mdi-volume-off",					
					"enable" 	: true,		

				},
				{
					"key"  		: "refresh",
					"text" 		: "refresh",					
					"type" 		: "btn",
					"action" 	: "refresh",
					"tooltip" 	: "",					
					"color" 	: "primary",
					"color1" 	: "primary",					
					"icon"   	: "mdi-refresh",
					"enable" 	: true,	

				},
				{
					"key"  		: "options",
					"text" 		: "options",					
					"type" 		: "menu",
					"menu"		: "toolbar_options",
					"action" 	: "",
					"tooltip" 	: "",					
					"color" 	: "",
					"icon"   	: "",
					"enable" 	: true,	

				},
			],
			input 		: '',
			list_show 	: {
				keyboard : ['dashboard', 'dashboards', 'reports', 'dashboard_lpr', 'user', 'playback', 'parameters', 'settings', 'settings_alarm', 'new_device', 'settings_device'],
			},		    
			show_alert				: {
				disk : {
					active 	: false,
					icon 	: 'mdi-harddisk',
					color 	: 'error',
					tooltip : '',
				},
			},
			ID_notification : "toolbar",
			bus 			: {},
			info_item 		: {},
			show 			: {
				dashboards 	: true,
				draggables 	: true,
				sound 		: true,
				keyboard 	: true, 
				save_dashboard : true,
			},			
			modal_active 	: false,

			// draw_option:['draggable','resizable','prevent_collision', 'vertical_compact','responsive']
		}), //data
		
		watch : {			
			virtual_Keyboard(v){
				localStorage.setItem('virtual_Key_board', v);
			},
			alr_sound(v){
				localStorage.setItem('alert_sound_status', JSON.stringify(v));
			},
			modal_active(v){
				localStorage.setItem('modal_active', JSON.stringify(v));
			},

			current_router: function(val){
				console.log(val , 'currentRoute toolbar')				
			}, // curren_router

		}, //watch
		
		created(){		
			// this.get_list();

		}, //created	

		computed:{
			
			currentRoute: function(){					
				if (this.$route.name == "dashboard") {
					// this.dashboard_selected = {
    				// 	name 	: "",
    				// 	id 		: null,
    				// }
					// if (this.list_dashboards && this.list_dashboards.length > 1) {						
					//     this.actions("options_dashboards");
					// }
    				this.show.save_dashboard = true;
				}else{
    				this.show.save_dashboard = false;

				}
				// console.log("rOUTE : **==========" , this.$route.name)
				if (this.$route && this.$route.name && this.$route.name.includes('dashboard')) {
					this.show.dashboards = true;			
					this.show.edit = true;
					this.show.delete = true;
					// this.show.options = true;
				
					let modul = this.$store.getters["auth/permission"]("dashboard");					
			        if (!modul.can_add) {			        	
						this.show.save_dashboard = false;
			        }
			        if (!modul.can_edit) {			        	
    					this.show.edit = false;
						// this.show.options = false;

			        }
			        if (!modul.can_delete) {			        	
    					this.show.delete = false;
			        }
					
				}else{
					this.show.dashboards = false;

				}

				return this.$route.name;
			}, // currentRoute

		}, // computed

		
		methods:{

			actions(act, item, opt){
				// console.log("profile actions toolbar : ", act, item, opt)
				if (act == 'keyboard') {
					this.virtual_Keyboard 			= !this.virtual_Keyboard;
					this.option_active.keyboard     = this.virtual_Keyboard;
				}
				if (act == 'sound') {
					this.alert_sounds();
				}
				if (act == 'refresh') {
					this.reload()
					
				}
							
			}, // actions

			renderAlertMode(){
				// console.log("Send alert mode ", this.alertMode)
				EventBus.$emit("setAlertMode",this.alertMode)
			},
			
       		reload(){
       			// console.log("main reload", location.localhost)
       			if(location.hostname == `.` || location.hostname == `chromewebdata` || location.localhost == `.`){ // localhost
       				// console.log("main reload", location.localhost)
       				mainWindow.reload();
       				// win.reload()
       				// remote.getCurrentWindow().reload();
       				 // getCurrentWindow().reload()

       			}else {
       				location.reload(); 
       			}
       		}, // reload

       		alert_sounds(){
       			this.alr_sound = !this.alr_sound;
       			this.option_active.sound = this.alr_sound;
       			this.$Sounds.setIsSoundActive(this.alr_sound);
       			this.send_status_sound();
       		
       		}, //

       		send_status_sound(){
       			EventBus.$emit('is_alert_sound', this.alr_sound);
       		
       		}, // send status sound
       		
		}, //methods

		
		mounted() {			
			let  vm 	= this;
	    	
			let temp_bus = "notifications_modal" + this.ID_notification; 
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action)=>{
				if (action) {
					this.del();
				}
			});

			EventBus.$on('responsive', (size) => {
				if (size) {

					// console.log("responsive toolbar : ", size);
					if (size.width < 1397) {
						vm.width_toolbar.bar 	 	 = 600;
						vm.width_toolbar.bar_min 	 = 500;						
						vm.width_toolbar.cpu 		 = true;
						vm.width_toolbar.ram 		 = true;
						vm.width_toolbar.mw_card_cpu = 150; 
						vm.width_toolbar.mw_card_ram = 140;						
						vm.width_toolbar.w_card_cpu  = 155;
						vm.width_toolbar.w_card_ram  = 160;
						vm.width_toolbar.profile 	 = true;
						vm.width_toolbar.draggable 	 = true;
						vm.width_toolbar.keyboard 	 = true;
						vm.width_toolbar.sound   	 = true;
						vm.width_toolbar.refresh 	 = true;
						vm.width_toolbar.options 	 = false;
					}
					if (size.width < 962) {
						vm.width_toolbar.bar 	 	 = 300;
						vm.width_toolbar.bar_min 	 = 300;						
						vm.width_toolbar.cpu 		 = true;
						vm.width_toolbar.ram 		 = true;
						vm.width_toolbar.mw_card_cpu = 120; 
						vm.width_toolbar.mw_card_ram = 100;						
						vm.width_toolbar.w_card_cpu  = 125;
						vm.width_toolbar.w_card_ram  = 125;
						vm.width_toolbar.profile 	 = false;
						vm.width_toolbar.keyboard 	 = false;
						vm.width_toolbar.draggable 	 = true;
						vm.width_toolbar.sound   	 = false;
						vm.width_toolbar.refresh 	 = false;
						vm.width_toolbar.options 	 = true;
					}
					if (size.width > 962 && size.width < 1150) {
						vm.width_toolbar.bar 	 	 = 500;
						vm.width_toolbar.bar_min 	 = 400;						
						vm.width_toolbar.cpu 		 = true;
						vm.width_toolbar.ram 		 = true;
						vm.width_toolbar.mw_card_cpu = 100;
						vm.width_toolbar.mw_card_ram = 100;						
						vm.width_toolbar.w_card_cpu  = 150;
						vm.width_toolbar.w_card_ram  = 155;
						vm.width_toolbar.profile 	 = false;
						vm.width_toolbar.keyboard 	 = true;
						vm.width_toolbar.draggable 	 = true;
						vm.width_toolbar.sound   	 = false;
						vm.width_toolbar.refresh 	 = false;
						vm.width_toolbar.options 	 = true;
					}
					if (size.width < 801) {
						vm.width_toolbar.bar 	 	 = 300;
						vm.width_toolbar.bar_min 	 = 280;						
						vm.width_toolbar.cpu 		 = true;
						vm.width_toolbar.ram 		 = true;
						vm.width_toolbar.mw_card_cpu = 80;
						vm.width_toolbar.mw_card_ram = 70;
						vm.width_toolbar.w_card_cpu  = 100;
						vm.width_toolbar.w_card_ram  = 100;
						vm.width_toolbar.profile 	 = false;
						vm.width_toolbar.keyboard 	 = false;
						vm.width_toolbar.draggable 	 = true;
						vm.width_toolbar.sound   	 = false;
						vm.width_toolbar.refresh 	 = false;
						vm.width_toolbar.options 	 = true;
					}
					if (size.width > 1397) {
						vm.width_toolbar.bar 	 	 = 705;
						vm.width_toolbar.bar_min 	 = 500;												
						vm.width_toolbar.cpu 		 = true;
						vm.width_toolbar.ram 		 = true;
						vm.width_toolbar.mw_card_cpu = 100; 						
						vm.width_toolbar.mw_card_ram = 90;						
						vm.width_toolbar.w_card_cpu  = 245;
						vm.width_toolbar.w_card_ram  = 240;
						vm.width_toolbar.profile 	 = true;
						vm.width_toolbar.keyboard 	 = true;
						vm.width_toolbar.draggable 	 = true;
						vm.width_toolbar.sound   	 = true;
						vm.width_toolbar.refresh 	 = true;
						vm.width_toolbar.options 	 = false;
					}

				}
			}); // responsive

			if (localStorage.getItem('virtual_Key_board')) {
				this.virtual_Keyboard 		= JSON.parse(localStorage.getItem('virtual_Key_board'));
				this.option_active.keyboard = this.virtual_Keyboard;
			}

			// Cargar estado de sonidos de alerta desde localStorage
			if (localStorage.getItem('alert_sound_status')) {
				this.alr_sound = JSON.parse(localStorage.getItem('alert_sound_status'));
				this.option_active.sound = this.alr_sound;
			}

			// Cargar estado de modal activo desde localStorage
			if (localStorage.getItem('modal_active')) {
				this.modal_active = JSON.parse(localStorage.getItem('modal_active'));
			}

			if (this.alr_sound) {
				this.$Sounds.setIsSoundActive(this.alr_sound);
			}

			const socketCounting = io.connect(this.$protocol_socket + this.$localsocket+':'+this.$port_socket+'/statistics', this.$setting_socket);				

		
			// socketCounting.transports= ['websocket']; 
			socketCounting.upgrade = false;  
			this.$emit('connection_status', 'Connecting statistics');
			// console.log(socketCounting, 'socket statistics')
		    let si 	  		 = this;
		    let limit_rect 	 = 3;
		    let count 		 = 0;	
		    let sum_reconect = 100;
		    
		    // Guardar referencia del socket para poder limpiarlo
		    this.socketCounting = socketCounting;
	     	socketCounting.on('service', function(message) {
	     		if (message) {

		     		si.system = message;	 
		     		let v 		 = message;
		     		let ram_t 	 = 0, 
						ram_used = 0, 
						num 	 = 0 , 
						num1	 = 0,
						num_cpu  = 0, 
						brand;
					let cpu_perc = 0;
					num_cpu 	 = parseFloat(v.cpu_u);
					num 		 = parseFloat(v.men.total);
					num1 		 = parseFloat(v.men.available); //used
					// console.log(v, 'cpu')
					if (v) {
				     	ram_t 	 = (num/1048576).toFixed(2);// 1024)/1024
				     	let used = (num1/1048576).toFixed(2); // 1024)/1024
				     	let disp = ram_t-used;
				     	ram_used = (((disp*100)/ram_t)).toFixed(2);
				     	cpu_perc = (num_cpu*100).toFixed(1);
				     	brand 	 = v.cpu.brand;
		     		}
		     		si.percent_cpu 	= cpu_perc;
		     		si.cpu 		 	= brand;
		     		si.os_ram 	 	= ram_t;
		     		si.percent 	 	= ram_used;
		     		si.disks 		= message &&  message.disk &&  message.disk.states ? message.disk.states : null;
		     		if (message && message.disk && message.disk.states && message.disk.states.length > 0) {
		     			if (message.disk.limit_exceeded) {

			     			let ds = message.disk.states;
			     			let lm = message.disk.limit;
			     			// console.log("DISK ",ds)
			     			if (ds && ds.length > 0) {
			     				let limit = { disks : [], uses : []};
			     				ds.forEach( (d, idx_d) =>{
			     					// console.log("USE : ", d.use, "\n z : ", lm)
					                if (d && lm.filter( z => ( z && z < parseInt(d.use))).length > 0) {
					                	
					                    limit.disks.push(d.disk);
					                    limit.uses.push(d.use);
					                    
					                } 
					                if (idx_d == ds.length - 1) {
					                	vm.show_alert.disk.active  = true;
					                	vm.show_alert.disk.tooltip = "Disks " + limit.disks + " its over " + limit.uses;
					                	/*EventBus.$emit('notifications_modal',{
					                    	type 	: 'warning',
					                    	message : "Disks " + limit.disks + " its over " + limit.uses
					                    })*/
					                }

					            })
			     			}
		     			}else{
		     			
		     				if (vm.show_alert.disk.active) {
		     					vm.show_alert.disk.active 	= false;
		     					vm.show_alert.disk.tooltip 	= "";
		     				}
		     			}
		     		}
		     		// console.log(message, 'statistics')    			     		
	     		}
	     	});
     		socketCounting.on('connect', () => {
				// ev.status_message='conect';//msg;
	  			// ev.color_message='success';
		  		// console.log(socketCounting.connected ,'connected statistics'); // false
		  		this.$emit('connection_status', 'Connected statistics');
		  		this.$emit('connection_status', false);
		  		// console.log('Connected statistics')
			});
			socketCounting.on("disconnect", (reason) => {
	     		

			  	// console.log("socket disconnect toolbar : ", reason );
			  	/*const timer = setTimeout(()=>{
					  		
				  	// if (count < limit_rect) {
				  		socketCounting.connect();
				  		count += sum_reconect;
				  	// }
				  	// if (count == limit_rect) {
				  		// console.log("limit reconnect reached ", count)
				  	// }
			  		clearTimeout(timer)
		  		}, 5000 + count)*/
	     		
			});
			socketCounting.on("connect_error", () => {
			  	// console.log("Error connect socket toolbar: " , socketCounting);
				  	/*const timer = setTimeout(()=>{

				  	// if (count < limit_rect) {
				  		socketCounting.connect();
				  		count += sum_reconect;
				  	// }
				  	// if (count == limit_rect) {
				  		// console.log("limit reconnect reached ", count)
				  	// }
					clearTimeout(timer)
		  		}, 5000 + count)*/
	     		
			  	// socketCounting.disconnect(true)
			  	// socketCounting.close()
			  	// socketCounting = null; // not work for const
			  	// socketCounting.emit('disconnect'); // no test
			  	// socketCounting.Disconnect()
			});
			  	// socketCounting.socket.autoConnect = false;
   
	    }, // mounted

	    beforeDestroy(){
	    	// this.$Helper.clear_bus(this.bus, EventBus, "toolbar");
	    	
	    	// Limpiar socket de statistics
	    	if (this.socketCounting) {
	    		this.socketCounting.disconnect();
	    		this.socketCounting = null;
	    	}
	    	
	    	// Limpiar EventBus listeners
	    	if (this.bus) {
	    		Object.keys(this.bus).forEach(key => {
	    			if (this.bus[key]) {
	    				EventBus.$off(key, this.bus[key]);
	    			}
	    		});
	    		this.bus = {};
	    	}
	    }

	};